import { Link, Outlet, useLocation } from 'react-router'

const tabs = [
	{ label: 'Results', to: '/tournaments/results' },
	{ label: 'Rules', to: '/tournaments/rules' },
	{ label: 'Swiss Explained', to: '/tournaments/swiss' },
	{ label: 'CancelGammon', to: '/tournaments/cancel-gammon' },
]

function handleTabClick(to: string) {
	sessionStorage.setItem('tournaments-last-tab', to)
}

export default function TournamentsLayout() {
	const location = useLocation()

	return (
		<main className="font-poppins w-[calc(100%-12px)]">
			<div className="px-4">
				<h1 className="text-center text-4xl">Tournaments</h1>
				<nav className="mt-4 mb-8 flex justify-center gap-1 border-b border-slate-200 dark:border-slate-700">
					{tabs.map((tab) => {
						const isActive = location.pathname === tab.to
						return (
							<Link
								key={tab.to}
								to={tab.to}
								onClick={() => handleTabClick(tab.to)}
								className={
									isActive
										? 'border-b-2 border-slate-900 px-4 pb-2 text-sm font-semibold dark:border-slate-100'
										: 'px-4 pb-2 text-sm text-slate-500 hover:text-slate-900 dark:hover:text-slate-100'
								}
							>
								{tab.label}
							</Link>
						)
					})}
				</nav>
			</div>
			<Outlet />
		</main>
	)
}
